var _g, _g2, _path, _g3, _path2, _g4, _path3, _g5, _path4, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFramesIphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 288,
    viewBox: "0 0 142 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_213_5176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.983,
    width: 138.741,
    height: 287.156,
    rx: 22.954,
    fill: "#393348"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 56.082c0-.181.146-.328.327-.328h.655v10.49h-.655a.33.33 0 0 1-.328-.328z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 56.082c0-.181.146-.328.327-.328h.655v10.49h-.655a.33.33 0 0 1-.328-.328z",
    fill: "url(#paint0_linear_213_5176)",
    fillOpacity: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 56.082c0-.181.146-.328.327-.328h.655v10.49h-.655a.33.33 0 0 1-.328-.328z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 76.893c0-.18.146-.328.327-.328h.655V97.85h-.655a.33.33 0 0 1-.328-.328z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 76.893c0-.18.146-.328.327-.328h.655V97.85h-.655a.33.33 0 0 1-.328-.328z",
    fill: "url(#paint1_linear_213_5176)",
    fillOpacity: 0.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 76.893c0-.18.146-.328.327-.328h.655V97.85h-.655a.33.33 0 0 1-.328-.328z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 104.503c0-.181.146-.328.327-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 104.503c0-.181.146-.328.327-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    fill: "url(#paint2_linear_213_5176)",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 104.503c0-.181.146-.328.327-.328h.655v21.284h-.655a.33.33 0 0 1-.328-.328z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1.983 30.344H3.87v1.966H1.983zm136.851 0h1.887v1.966h-1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 111.884 0)",
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M111.884 0h1.887v1.966h-1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 140.712 255.52)",
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M140.712 255.52h1.887v1.878h-1.887z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 3.872 255.52)",
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M3.872 255.52h1.887v1.966H3.872z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 33.246 285.269)",
    fill: "#4C4254",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.246 285.269h1.887v1.966h-1.887z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.707 91.788a.33.33 0 0 0-.328-.328h-.656v33.999h.656a.33.33 0 0 0 .328-.328z",
    fill: "#B4B0B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.707 91.788a.33.33 0 0 0-.328-.328h-.656v33.999h.656a.33.33 0 0 0 .328-.328z",
    fill: "url(#paint3_linear_213_5176)",
    fillOpacity: 0.8
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.707 91.788a.33.33 0 0 0-.328-.328h-.656v33.999h.656a.33.33 0 0 0 .328-.328z",
    stroke: "#AFABAE",
    strokeWidth: 0.164
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_5176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.87,
    y: 1.769,
    width: 134.966,
    height: 282.202,
    rx: 21.236,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.688 1.77h27.327l-.275.727a.71.71 0 0 1-.662.457H58.625a.71.71 0 0 1-.662-.457z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_213_5176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.117,
    y: 6.016,
    width: 126.472,
    height: 273.707,
    rx: 17.251,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.117 6.022h126.471v273.696H8.117z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_213_5176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.567,
    y: 275.64,
    width: 45.096,
    height: 1.683,
    rx: 0.841,
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.489 81.135H23.201a2.004 2.004 0 0 0-2.005 2.004v95.288c0 1.107.898 2.004 2.005 2.004h95.288a2.004 2.004 0 0 0 2.004-2.004V83.139a2.005 2.005 0 0 0-2.004-2.004",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.484 83.139h-91.28a2.004 2.004 0 0 0-2.003 2.004v91.28c0 1.106.897 2.004 2.004 2.004h91.279a2.005 2.005 0 0 0 2.005-2.004v-91.28a2.005 2.005 0 0 0-2.005-2.004",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.489 182.433H23.201a2.004 2.004 0 0 0-2.005 2.004v15.851c0 1.107.898 2.004 2.005 2.004h95.288a2.004 2.004 0 0 0 2.004-2.004v-15.851a2.004 2.004 0 0 0-2.004-2.004",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.302 189.732a.99.99 0 0 0-.447-.744q-.393-.267-.988-.268-.426 0-.738.136a1.14 1.14 0 0 0-.484.365.86.86 0 0 0-.169.525q0 .247.115.426.12.18.308.301.193.119.413.2.22.078.423.128l.677.176q.33.082.68.22.348.14.646.366t.48.562q.187.335.187.801 0 .59-.305 1.046-.3.457-.876.721-.572.264-1.384.264-.779 0-1.347-.247a2.07 2.07 0 0 1-.89-.701 2.03 2.03 0 0 1-.355-1.083h1.049q.03.377.243.626.218.247.552.369.339.119.741.119.444 0 .788-.139a1.33 1.33 0 0 0 .549-.392q.2-.254.2-.593a.73.73 0 0 0-.177-.504 1.3 1.3 0 0 0-.47-.325 5 5 0 0 0-.667-.226l-.819-.224q-.831-.226-1.32-.666-.483-.441-.483-1.164 0-.6.325-1.046.324-.447.88-.694a3 3 0 0 1 1.252-.25q.704 0 1.241.247.542.247.853.68.312.43.325.988zm8.108.433h-1.056a1.6 1.6 0 0 0-.632-1.032q-.24-.18-.538-.27a2.1 2.1 0 0 0-.626-.092q-.6 0-1.073.301-.47.302-.745.884-.27.581-.27 1.421 0 .846.27 1.428.274.582.748.879t1.066.298q.328 0 .623-.088.297-.091.538-.267a1.64 1.64 0 0 0 .64-1.019l1.055.004q-.084.51-.328.94-.24.428-.62.738a2.8 2.8 0 0 1-.859.477 3.2 3.2 0 0 1-1.056.169q-.9 0-1.604-.426a3 3 0 0 1-1.11-1.228q-.402-.8-.402-1.905 0-1.11.406-1.905.405-.8 1.11-1.225a3 3 0 0 1 1.6-.43q.552 0 1.029.159.48.156.863.46.383.302.633.738.25.433.338.991m1.79 4.677h-1.11l2.494-6.93h1.208l2.494 6.93h-1.11l-1.96-5.672h-.053zm.186-2.714h3.6v.88h-3.6zm11.494-4.216v6.93h-.96l-3.523-5.083h-.065v5.083h-1.045v-6.93h.967l3.526 5.089h.065v-5.089zm4.047 0h1.27l2.205 5.387h.082l2.206-5.387h1.269v6.93h-.995v-5.015H83.9l-2.044 5.005h-.826l-2.044-5.008h-.064v5.018h-.995zm8.552 6.93v-6.93h4.345v.9h-3.3v2.111h3.073v.897h-3.072v2.122h3.34v.9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.81 97.713h2.003v2.004H53.81zm2.003 0h2.005v2.004h-2.005zm4.007 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005zm4.011 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004H69.84zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 97.713h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 97.713h2.004v2.004h-2.004zm2.008 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.866 97.713h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm-28.061 2.004h2.004v2.004h-2.004zm2.005 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005zm4.011 0h2.004v2.004h-2.004zm10.016 0h2.004v2.004h-2.004zm6.014 0h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm-32.066 2.004h2.003v2.004H53.81zm6.01 0h2.004v2.004h-2.005zm6.016 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 101.721h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 101.721h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm2.008 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004H83.87zm2.006 0h2.004v2.004h-2.004zm-22.046 2.004h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 103.725h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.842 103.725h2.004v2.004H69.84zm4.006 0h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004zm4.012 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004H83.87zm-20.04 2.004h2.004v2.004h-2.005zm12.022 0h2.004v2.004h-2.004zm4.012 0h2.004v2.004h-2.004zm6.012 0h2.004v2.004h-2.004zm-22.046 2.004h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm6.01 0h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm-22.043 4.01h2.005v2.005h-2.005zm8.017 0h2.004v2.005h-2.005zm4.008 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.842 111.743h2.004v2.005H69.84zm2.006 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 111.743h2.004v2.005h-2.005zm2.004 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 111.743h2.004v2.005h-2.004zm8.02 0h2.004v2.005h-2.004zm-26.056 2.004h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004zm6.012 0h2.004v2.005h-2.004zm18.034 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005h-2.004zm4.012 0h2.005v2.005H97.9zm4.004 0h2.005v2.005h-2.005zm-58.117 2.004h2.004v2.005h-2.004zm4.01 0H49.8v2.005h-2.004zm6.013 0h2.003v2.005H53.81zm2.003 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 115.751h2.004v2.005h-2.004zm10.023 0h2.004v2.005h-2.004zm4.01 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 115.751h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004zm8.014 0h2.004v2.005h-2.004zm4.012 0h2.005v2.005H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 115.751h2.004v2.005h-2.004zm2.008 0h2.005v2.005h-2.005zm-58.121 2.004h2.004v2.005h-2.005zm14.028 0h2.004v2.005h-2.004zm4.01 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 117.755h2.004v2.005h-2.004zm2.005 0h2.004v2.005h-2.005zm2.005 0h2.005v2.005h-2.005zm4.011 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 117.755h2.004v2.005h-2.004zm6.01 0h2.004v2.005h-2.005zm2.004 0h2.004v2.005h-2.004zm6.014 0h2.004v2.005h-2.004zm4.01 0h2.004v2.005h-2.004zm6.014 0h2.005v2.005H91.89zm-54.115 2.004h2.004v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 119.759h2.004v2.005h-2.005zm4.008 0h2.004v2.005h-2.004zm2.008 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 119.759H49.8v2.005h-2.004zm4.006 0h2.004v2.005h-2.004zm10.022 0h2.005v2.005h-2.005zm8.017 0h2.004v2.005H69.84zm4.006 0h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005H83.87zm2.006 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005h-2.004zm2.008 0h2.005v2.005H91.89zm4.006 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 119.759h2.005v2.005H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 119.759h2.005v2.005h-2.005zm-62.127 2.004h2.004v2.005h-2.005zm4.01 0h2.004v2.005h-2.004zm10.018 0h2.004v2.005h-2.004zm2.007 0h2.003v2.005H53.81zm4.005 0h2.004v2.005h-2.004zm2.005 0h2.004v2.005h-2.005zm2.005 0h2.005v2.005h-2.005zm6.013 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.842 121.763h2.004v2.005H69.84zm10.022 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005H83.87zm2.006 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005h-2.004zm2.008 0h2.005v2.005H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 121.763h2.004v2.005h-2.004zm6.014 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 121.763h2.005v2.005h-2.005zm-60.119 2.005h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 123.768H49.8v2.004h-2.004zm4.006 0h2.004v2.004h-2.004zm2.007 0h2.003v2.004H53.81zm2.003 0h2.005v2.004h-2.005zm8.017 0h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004zm8.012 0h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004zm4.012 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004H83.87zm6.012 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 123.768h2.004v2.004h-2.004zm8.016 0h2.005v2.004h-2.005zm-56.109 2.004h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 125.772H49.8v2.004h-2.004zm8.016 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 125.772h2.004v2.004h-2.004zm4.01 0h2.005v2.004h-2.005zm6.013 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.842 125.772h2.004v2.004H69.84zm8.014 0h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm6.012 0h2.004v2.004h-2.004zm2.004 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 125.772h2.004v2.004h-2.004zm2.008 0h2.005v2.004h-2.005zm4.006 0h2.005v2.004h-2.005zm-62.127 2.004h2.004v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 127.776h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm2.008 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 127.776H49.8v2.004h-2.004zm6.013 0h2.003v2.004H53.81zm2.003 0h2.005v2.004h-2.005zm4.007 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005zm4.011 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 127.776h2.004v2.004h-2.004zm16.032 0h2.004v2.004H83.87zm4.008 0h2.004v2.004h-2.004zm4.012 0h2.005v2.004H91.89zm4.006 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 127.776h2.005v2.004H97.9zm4.004 0h2.005v2.004h-2.005zm-56.109 2.004h2.004v2.004h-2.004zm8.015 0h2.003v2.004H53.81zm2.003 0h2.005v2.004h-2.005zm10.023 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 129.78h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm4.004 0h2.004v2.004h-2.004zm8.018 0h2.004v2.004H83.87zm8.02 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 129.78h2.004v2.004h-2.004zm2.008 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 129.78h2.005v2.004H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 129.78h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 129.78h2.005v2.004h-2.005zm-64.129 2.004h2.004v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 131.784h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.787 131.784h2.004v2.004h-2.004zm16.033 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005zm6.013 0h2.004v2.004h-2.004zm8.014 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 131.784h2.004v2.004h-2.004zm6.014 0h2.004v2.004H83.87zm2.006 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89zm10.014 0h2.005v2.004h-2.005zm-64.129 2.004h2.004v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 133.788h2.004v2.004h-2.005zm6.016 0h2.004v2.004h-2.004zm8.015 0h2.003v2.004H53.81zm6.01 0h2.004v2.004h-2.005zm4.01 0h2.004v2.004h-2.005zm6.012 0h2.004v2.004H69.84zm4.006 0h2.004v2.004h-2.005zm6.016 0h2.004v2.004h-2.004zm4.006 0h2.004v2.004H83.87zm4.008 0h2.004v2.004h-2.004zm2.004 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89zm4.006 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 133.788h2.005v2.004H97.9zm4.004 0h2.005v2.004h-2.005zm-64.129 2.004h2.004v2.004h-2.005zm6.012 0h2.004v2.004h-2.004zm4.01 0H49.8v2.004h-2.004zm4.006 0h2.004v2.004h-2.004zm8.017 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.83 135.792h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 135.792h2.004v2.004h-2.005zm8.018 0h2.004v2.004h-2.004zm2.004 0h2.004v2.004H83.87zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.878 135.792h2.004v2.004h-2.004zm8.018 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 135.792h2.005v2.004H97.9zm4.004 0h2.005v2.004h-2.005zm-64.129 2.004h2.004v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 137.796h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.787 137.796h2.004v2.004h-2.004zm8.016 0h2.004v2.004h-2.004zm8.017 0h2.004v2.004h-2.005zm4.01 0h2.004v2.004h-2.005zm6.012 0h2.004v2.004H69.84zm2.006 0h2.004v2.004h-2.004zm4.004 0h2.004v2.004h-2.004zm6.014 0h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm8.012 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004h-2.005zm4.006 0h2.005v2.004h-2.005zM37.775 139.8h2.004v2.004h-2.005zm4.01 0h2.004v2.004h-2.004zm10.018 0h2.004v2.004h-2.004zm6.012 0h2.004v2.004h-2.004zm6.015 0h2.004v2.004h-2.005zm8.018 0h2.004v2.004h-2.004zm4.004 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 139.8h2.004v2.004h-2.004zm10.022 0h2.004v2.004h-2.004zm2.004 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 139.8h2.004v2.004h-2.004zm2.008 0h2.005v2.004h-2.005zm-58.121 2.004h2.004v2.004h-2.005zm20.04 0h2.004v2.004h-2.004zm2.005 0h2.004v2.004h-2.005zm4.01 0h2.004v2.004h-2.005zm8.018 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 141.804h2.004v2.004h-2.005zm6.016 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.866 141.804h2.004v2.004h-2.004zm2.004 0h2.004v2.004H83.87zm2.006 0h2.004v2.004h-2.004zm-48.101 2.004h2.004v2.004h-2.005zm4.01 0h2.004v2.004h-2.004zm10.018 0h2.004v2.004h-2.004zm4.01 0h2.005v2.004h-2.005zm18.035 0h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 143.808h2.004v2.004h-2.004zm6.014 0h2.004v2.004H83.87zm12.026 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 143.808h2.005v2.004H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 143.808h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 143.808h2.005v2.004h-2.005zm-64.129 2.004h2.004v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.779 145.812h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm2.008 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.797 145.812H49.8v2.004h-2.004zm4.006 0h2.004v2.004h-2.004zm2.007 0h2.003v2.004H53.81zm2.003 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 145.812h2.004v2.004h-2.004zm4.01 0h2.005v2.004h-2.005zm8.017 0h2.004v2.004H69.84zm4.006 0h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004zm4.012 0h2.004v2.004h-2.004zm20.038 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 145.812h2.005v2.004h-2.005zm-48.094 2.004h2.003v2.005H53.81zm2.003 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 147.816h2.004v2.005h-2.004zm2.005 0h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 147.816h2.004v2.005h-2.004zm4.01 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.848 147.816h2.004v2.005h-2.005zm8.018 0h2.004v2.005h-2.004zm2.004 0h2.004v2.005H83.87zm14.03 0h2.005v2.005H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 147.816h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 147.816h2.005v2.005h-2.005zm-46.091 2.004h2.005v2.005h-2.005zm4.007 0h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 149.82h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.842 149.82h2.004v2.005H69.84zm2.006 0h2.004v2.005h-2.004zm4.004 0h2.004v2.005h-2.004zm4.012 0h2.004v2.005h-2.004zm18.036 0h2.005v2.005H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 149.82h2.005v2.005h-2.005zm-46.092 2.004h2.003v2.005H53.81zm8.015 0h2.005v2.005h-2.005zm4.011 0h2.004v2.005h-2.004zm4.006 0h2.004v2.005H69.84zm6.01 0h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 151.824h2.004v2.005h-2.004zm6.014 0h2.004v2.005H83.87zm12.026 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 151.824h2.005v2.005H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 151.824h2.005v2.005h-2.005zm-44.089 2.004h2.005v2.005h-2.005zm8.017 0h2.004v2.005h-2.005zm4.008 0h2.004v2.005h-2.004zm6.01 0h2.004v2.005h-2.005zm6.016 0h2.004v2.005h-2.004zm16.032 0h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 153.828h2.005v2.005h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 153.828h2.005v2.005h-2.005zm-38.074 2.007h2.004v2.004h-2.005zm10.018 0h2.004v2.004h-2.005zm4.008 0h2.004v2.004h-2.004zm2.008 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.866 155.835h2.004v2.004h-2.004zm2.004 0h2.004v2.004H83.87zm4.008 0h2.004v2.004h-2.004zm4.012 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 155.835h2.004v2.004h-2.004zm2.008 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 155.835h2.005v2.004H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 155.835h2.005v2.004h-2.005zm-44.089 2.004h2.005v2.004h-2.005zm8.017 0h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.838 157.839h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm4.004 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 157.839h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm12.022 0h2.004v2.004h-2.004zm4.012 0h2.005v2.004H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 157.839h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 157.839h2.005v2.004h-2.005zm-46.091 2.002h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 159.841h2.004v2.004h-2.004zm6.015 0h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004zm8.012 0h2.004v2.004h-2.005zm2.004 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.856 159.841h2.004v2.004h-2.004zm4.01 0h2.004v2.004h-2.004zm16.034 0h2.005v2.004H97.9zm-42.087 2.006h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.815 161.847h2.004v2.004h-2.004zm2.005 0h2.004v2.004h-2.005zm2.005 0h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.83 161.847h2.004v2.004h-2.005zm2.006 0h2.004v2.004h-2.004zm8.012 0h2.004v2.004h-2.005zm8.018 0h2.004v2.004h-2.004zm2.004 0h2.004v2.004H83.87zm2.006 0h2.004v2.004h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.878 161.847h2.004v2.004h-2.004zm2.004 0h2.004v2.004h-2.004zm8.018 0h2.005v2.004H97.9z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.902 161.847h2.005v2.004h-2.005z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.775 98.716H50.8v12.025H38.775zm52.112 0h12.025v12.025H90.887zm-52.112 52.107H50.8v12.025H38.775z",
    stroke: "#000",
    strokeWidth: 2.004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.785 101.721h6.012v6.012h-6.012zm52.103 0H99.9v6.012h-6.012zm-52.103 52.107h6.012v6.013h-6.012zm12.025-44.089h2.003v2.004H53.81zm-4.009 4.008h2.004v2.005h-2.004zm8.014-4.008h2.004v2.004h-2.004zm-8.014 8.016h2.004v2.005h-2.004zm12.024-8.016h2.005v2.004h-2.005zm-12.024 12.024h2.004v2.005h-2.004zm16.035-12.024h2.004v2.004h-2.004zm-16.035 16.033h2.004v2.004h-2.004zm20.041-16.033h2.004v2.004H69.84zM49.801 129.78h2.004v2.004h-2.004zm24.047-20.041h2.004v2.004h-2.005zm-24.047 24.049h2.004v2.004h-2.004zm28.055-24.049h2.004v2.004h-2.004zm-28.055 28.057h2.004v2.004h-2.004zm32.065-28.057h2.004v2.004h-2.004zm-32.065 32.065h2.004v2.004h-2.004zm36.075-32.065h2.004v2.004h-2.004zm-36.075 36.073h2.004v2.004h-2.004zm36.075 0h2.004v2.004h-2.004zm0 2.004h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.876 149.82h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.876 151.824h2.004v2.005h-2.004zm8.012-4.008h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 149.82h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 151.824h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 153.828h2.004v2.005h-2.004zm-6.01-8.016h2.004v2.004h-2.004zm2.004 0h2.004v2.004h-2.004zm2.008 0h2.005v2.004H91.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.888 145.812h2.004v2.004h-2.004zm-8.012 8.016h2.004v2.005h-2.004z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.878 153.828h2.004v2.005h-2.004zm2.004 0h2.004v2.005h-2.004zm2.008 0h2.005v2.005H91.89zm-2.008-4.008h2.004v2.005h-2.004z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 51.06,
    y: 9.556,
    width: 40.348,
    height: 12.034,
    rx: 6.017,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.398,
    cy: 15.573,
    r: 2.056,
    transform: "rotate(-180 85.398 15.573)",
    fill: "url(#paint4_linear_213_5176)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.4,
    cy: 15.573,
    r: 1.33,
    fill: "url(#paint5_radial_213_5176)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.278 14.485a.92.92 0 0 0-.684.319 1.16 1.16 0 0 0-.283.77c0 .288.102.565.283.77a.92.92 0 0 0 .684.318z",
    fill: "url(#paint6_linear_213_5176)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_213_5176)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.157,
    cy: 15.089,
    r: 0.363,
    fill: "#50326D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_213_5176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.521 16.663a.92.92 0 0 0 .684-.319c.182-.204.284-.481.284-.77 0-.288-.102-.565-.284-.77a.92.92 0 0 0-.684-.318z",
    fill: "url(#paint7_linear_213_5176)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_213_5176)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.641,
    cy: 16.057,
    r: 0.363,
    fill: "url(#paint8_linear_213_5176)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_213_5176",
    x: 1.983,
    y: 0,
    width: 138.741,
    height: 287.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.983,
    in: "SourceAlpha",
    result: "effect1_innerShadow_213_5176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.384766 0 0 0 0 0.331597 0 0 0 0 0.416667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.328,
    in: "SourceAlpha",
    result: "effect2_innerShadow_213_5176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.733333 0 0 0 0 0.721569 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_213_5176",
    result: "effect2_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_213_5176",
    x: 0.917,
    y: 55.345,
    width: 1.475,
    height: 10.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_213_5176",
    x: 0.917,
    y: 76.156,
    width: 1.475,
    height: 21.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_213_5176",
    x: 0.917,
    y: 103.765,
    width: 1.475,
    height: 21.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_213_5176",
    x: 140.641,
    y: 91.05,
    width: 1.475,
    height: 34.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.328,
    dy: -0.328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_213_5176",
    x: 57.688,
    y: 1.297,
    width: 27.327,
    height: 1.657,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.472
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.236
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 0 0.220833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_213_5176",
    x: 83.983,
    y: 14.157,
    width: 1.623,
    height: 2.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164,
    result: "effect1_foregroundBlur_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_213_5176",
    x: 83.645,
    y: 13.577,
    width: 3.025,
    height: 3.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.575,
    result: "effect1_foregroundBlur_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_213_5176",
    x: 85.194,
    y: 14.158,
    width: 1.623,
    height: 2.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.164,
    result: "effect1_foregroundBlur_213_5176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_213_5176",
    x: 84.895,
    y: 15.311,
    width: 1.492,
    height: 1.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.192,
    result: "effect1_foregroundBlur_213_5176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_5176",
    x1: 1.491,
    y1: 55.754,
    x2: 1.491,
    y2: 66.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_213_5176",
    x1: 1.491,
    y1: 76.566,
    x2: 1.491,
    y2: 97.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_213_5176",
    x1: 1.491,
    y1: 104.175,
    x2: 1.491,
    y2: 125.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_213_5176",
    x1: 141.215,
    y1: 91.46,
    x2: 141.215,
    y2: 125.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#C0B7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#605565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#605968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1E1423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_213_5176",
    x1: 83.705,
    y1: 14.485,
    x2: 86.971,
    y2: 16.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B0B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_213_5176",
    x1: 84.553,
    y1: 14.727,
    x2: 85.157,
    y2: 16.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#061127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_213_5176",
    x1: 86.247,
    y1: 16.421,
    x2: 85.642,
    y2: 14.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D6495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#061127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_213_5176",
    x1: 86.125,
    y1: 16.299,
    x2: 85.641,
    y2: 15.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3291AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3291AF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_5176"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.87,
    y: 1.769,
    width: 134.966,
    height: 282.202,
    rx: 21.236,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_213_5176"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.117,
    y: 6.016,
    width: 126.472,
    height: 273.707,
    rx: 17.251,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_213_5176"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.117 6.022h126.471v273.696H8.117z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_213_5176"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.117 6.021h126.471v274.597H8.117z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_213_5176",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.08856 .84666 -.85291 1.0966 85.4 15.452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#152457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramesIphone);
export default __webpack_public_path__ + "static/media/frames-iphone.052d2718c2f0294fa1394a213d2b37b1.svg";
export { ForwardRef as ReactComponent };